'use strict';

module.exports = function (ngModule) {
    // routes
    require('./routes')(ngModule);
    // controllers
    require('./controllers')(ngModule);
}


/** WEBPACK FOOTER **
 ** ./src/auth/index.js
 **/